import { ILpAdaptersStore } from './lpAdapters.interface';

export const lpAdaptersInitialState: ILpAdaptersStore = {
  adapters: [],
};

// Preconfigured demo adapter: CP manages its connection settings itself,
// so the UI must not request the schema or render connection sections for it.
export const DEMO_CBRIDGE_ADAPTER = 'DEMO_CBRIDGE';
